// Framework
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { EmailActionsGuard } from '@employer/app/guards/email-actions.guard'
import { redirectLoggedInToHomeGuard, userCanAccessTermsPage, userCanAccessVerifyPage } from '@engineering11/auth-web'
// This 'DenyGuard' is used to block users from gettign back to the 'auth' module post login
// All 'user' management should be done in a 'users' module. 'auth' is not reusable for user management
import { FileNotFoundComponent } from '../_404/404.component'
// Platform specific
import { AuthenticationComponent } from './authentication.component'
import { ActionSuccessComponent } from './views/action-success/action-success.component'
import { AuthenticationCodeWallComponent } from './views/code-wall/code-wall.component'
import { EmailActionsComponent } from './views/email-actions/email-actions.component'
import { AuthenticationLoginComponent } from './views/login/login.component'
import { AuthenticationRecoverComponent } from './views/recover/recover.component'
import { AuthenticationRegisterCompanyComponent } from './views/register-company/register-company.component'
import { RegisterInviteComponent } from './views/register-invite/register-invite.component'
import { AuthenticationRegisterVerifyComponent } from './views/register-verify/register-verify.component'
import { AuthenticationRegisterComponent } from './views/register/register.component'
import { AuthenticationTermsComponent } from './views/terms/terms.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: 'auth/terms',
    component: AuthenticationComponent,
    children: [
      {
        path: '',
        component: AuthenticationTermsComponent,
        ...userCanAccessTermsPage(),
      },
    ],
  },
  {
    path: 'auth/terms/:deepLink',
    component: AuthenticationComponent,
    children: [
      {
        path: '',
        component: AuthenticationTermsComponent,
        ...userCanAccessTermsPage(),
      },
    ],
  },
  {
    path: 'auth',
    component: AuthenticationComponent,
    children: [
      {
        path: 'login',
        component: AuthenticationLoginComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'login/:deepLink',
        component: AuthenticationLoginComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'code',
        component: AuthenticationCodeWallComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'recover',
        component: AuthenticationRecoverComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'register',
        component: AuthenticationRegisterComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'register/:deepLink',
        component: AuthenticationRegisterComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'register-company',
        component: AuthenticationRegisterCompanyComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'register-verify',
        component: AuthenticationRegisterVerifyComponent,
        ...userCanAccessVerifyPage(),
      },
      {
        path: 'register-verify/:deepLink',
        component: AuthenticationRegisterVerifyComponent,
        ...userCanAccessVerifyPage(),
      },
      {
        path: 'register-invite/:code',
        component: RegisterInviteComponent,
        ...redirectLoggedInToHomeGuard(),
      },
      {
        path: 'actions',
        component: EmailActionsComponent,
        canActivate: [EmailActionsGuard],
      },
      {
        path: 'action-success/:mode',
        component: ActionSuccessComponent,
      },
      {
        path: '**',
        component: FileNotFoundComponent,
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
